import { Controller } from '@hotwired/stimulus'

import leaflet from 'leaflet'

leaflet.Marker.prototype.options.icon = leaflet.divIcon({
  html: '<i class="fas fa-map-marker-alt text-lg"></i>',
  iconSize: [30, 30],
  className: 'text-center bg-transparent fs-4 text-primary'
})

export default class extends Controller {
  connect () {
    this.map = leaflet.map(this.element, { editable: true })

    leaflet.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(this.map)

    this.map.setView([62.27, -101.87], 3)

    try {
      const parsedJson = JSON.parse(this.element.dataset.geojson)
      const geoJsonFeature = leaflet.geoJSON(parsedJson).addTo(this.map)
      this.map.fitBounds(geoJsonFeature.getBounds(), { maxZoom: 5 })
    } catch (e) {
      console.error(e)
    }
  }

  disconnect () {
    this.map.remove()
  }
}
